import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-circulation-rules',
  templateUrl: './circulation-rules.component.html',
  styleUrls: ['./circulation-rules.component.css']
})
export class CirculationRulesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
